import { render, staticRenderFns } from "./PaymentsWrapper.vue?vue&type=template&id=42f9ca4b&"
import script from "./PaymentsWrapper.vue?vue&type=script&lang=js&"
export * from "./PaymentsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports